module.exports = __webpack_public_path__ + "img/Invasion-CRC_10X_WTA.41efd582.png";